import React from 'react';

interface ModeToggleProps {
  mode: 'simple' | 'advanced';
  onChange: (mode: 'simple' | 'advanced') => void;
}

export const ModeToggle: React.FC<ModeToggleProps> = ({ mode, onChange }) => {
  return (
    <div className="flex items-center gap-3 mb-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
      <span className="text-sm font-medium text-gray-700">Mode:</span>
      
      <div className="flex bg-white rounded-md shadow-sm border border-gray-300">
        <button
          onClick={() => onChange('simple')}
          className={`px-4 py-2 text-sm font-medium rounded-l-md transition-colors ${
            mode === 'simple'
              ? 'bg-orange-500 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          }`}
        >
          Simple (3 Fields)
        </button>
        <button
          onClick={() => onChange('advanced')}
          className={`px-4 py-2 text-sm font-medium rounded-r-md transition-colors border-l ${
            mode === 'advanced'
              ? 'bg-orange-500 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          }`}
        >
          Advanced (13 Fields + Google Sheets)
        </button>
      </div>

      <div className="ml-auto text-xs text-gray-500">
        {mode === 'simple' ? (
          <span>Quick value map: Business Driver, Pain Point, Measurable Outcome</span>
        ) : (
          <span>Full value map with Google Sheets snippet generation</span>
        )}
      </div>
    </div>
  );
};
